module.exports = __webpack_public_path__ + "static/media/Placaj ceramic Klinker Glasgow.11dd6f42.jpg";